import Link from "next/link";
import type * as React from "react";

import { useCertification } from "~/hooks";
import { getAcronymForCertification } from "~/utils/helpers";

type CertificationTracksProps = {};

/**
 * BI-CPT course plan only. The CPT certification study plan (NCCA exam prep)
 * is a separate selector/navbar entry — not a nested button under BI-CPT.
 */
const CertificationCoursePlanButtons: React.FC<
	CertificationTracksProps
> = ({}) => {
	const { certification } = useCertification();

	return (
		<div className="flex flex-col gap-4 text-center">
			<Link
				href={`/certifications/${certification.slug}/recommended-course-plan`}
				className="w-full rounded-xl bg-orange-100 px-4 py-2.5 font-medium text-orange-900 hover:bg-orange-200 dark:bg-orange-300/40 dark:text-orange-50 dark:hover:bg-orange-300/50"
			>
				{getAcronymForCertification(certification)} Course Plan
			</Link>
		</div>
	);
};

export default CertificationCoursePlanButtons;
